import React, {useCallback, useState} from "react";
import {Box, Button, Modal, Stack, TextField, Typography,} from "@mui/material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function ModalMatchCardByPatientId({
                                                      id,
                                                      open,
                                                      handleClose,
                                                      handleSubmit,
                                                  }) {
    const [patientId, setPatientId] = useState("");

    const handleFormSubmit = useCallback(
        (e) => {
            e.preventDefault();
            handleSubmit(id, patientId);
            handleClose();
        },
        [patientId, id, handleSubmit, handleClose]
    );

    return (
        <Modal open={open} onClose={handleClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>
                    Сопоставить с картой по ID пациента
                </Typography>
                <form onSubmit={handleFormSubmit}>
                    <Stack spacing={2}>
                        <TextField
                            label="ID пациента"
                            helperText='Это значение можно взять из адресной строки (последнее число) на странице карточки пациента в CRM'
                            value={patientId}
                            onChange={(e) => setPatientId(e.target.value)}
                            required
                            fullWidth
                        />
                        <Button type="submit" variant="contained">
                            Подтвердить
                        </Button>
                    </Stack>
                </form>
            </Box>
        </Modal>
    );
}
